import { render, staticRenderFns } from "./source.vue?vue&type=template&id=56b6bdcd"
import script from "./source.vue?vue&type=script&lang=js"
export * from "./source.vue?vue&type=script&lang=js"
import style0 from "./source.vue?vue&type=style&index=0&id=56b6bdcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports